/**
 * Task entity -- Domain model for tasks.
 * Pure data structure, no external dependencies.
 *
 * @module domain/entities/Task
 */

export const TASK_STATUSES = ['pending', 'in_progress', 'completed', 'cancelled'];

export const WELL_KNOWN_TAGS = {
  template:          { label: 'plantilla',  color: '#d29922' },
  'agent-generated': { label: 'agente',     color: '#a371f7' },
  migration:         { label: 'migracion',  color: '#6e7681' },
  api:               { label: 'api',        color: '#58a6ff' },
  panel:             { label: 'panel',      color: '#238636' }
};

export function isTemplate(task) {
  return (task?.tags || []).includes('template');
}

export function getVersion(task) {
  return task?.metadata?.version ?? null;
}

export function getTemplateSource(task) {
  return task?.metadata?.template_source ?? null;
}

export function formatVersion(task) {
  const v = getVersion(task);
  return v ? `v${v}` : null;
}

export function createTask({ title, description, projectKey, status, priority, tags, metadata }) {
  return {
    id: null,
    title: title || '',
    description: description || '',
    projectKey: projectKey || 'General',
    status: TASK_STATUSES.includes(status) ? status : 'pending',
    priority: priority || 'medium',
    tags: tags || [],
    metadata: metadata || {},
    createdAt: null,
    updatedAt: null
  };
}
